(function () {
  const BODY_CLASS = "cookies_not_accepted";
  const BANNER_SELECTOR = ".pd-cookie-banner-window";
  const PANDECTES_SELECTOR = "#pandectes-banner";
  const ACCEPT_SELECTORS =
    ".cc-allow, .cc-close, .pd-cp-btn.pd-cp-ui-save, .cc-revoke";

  function isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      el.offsetParent !== null
    );
  }

  function setBodyClass(active) {
    document.body.classList.toggle(BODY_CLASS, active);
  }

  function waitForElementAndVisible(selector, callback, checkInterval = 100, timeout = 10000) {
    const startTime = Date.now();

    const interval = setInterval(() => {
      const elements = document.querySelectorAll(selector);
      const hasVisible = Array.from(elements).some(isVisible);

      if (elements.length > 0 && hasVisible) {
        clearInterval(interval);
        callback(elements.length);
      }

      if (Date.now() - startTime > timeout) {
        clearInterval(interval);
      }
    }, checkInterval);
  }

  waitForElementAndVisible(BANNER_SELECTOR, () => {
    setBodyClass(true);
  });

  document.addEventListener("click", (event) => {
    if (event.target.closest(ACCEPT_SELECTORS)) {
      setBodyClass(false);
      return;
    }

    if (event.target.closest("#omnisend-dynamic-container")) {
      setTimeout(() => setBodyClass(true), 100);
      return;
    }

    const banner = document.querySelector(BANNER_SELECTOR);
    const pandectes = document.querySelector(PANDECTES_SELECTOR);

    if (banner && (event.target === banner || banner.contains(event.target))) {
      return;
    }

    if (pandectes && !pandectes.classList.contains("cc-invisible")) {
      setBodyClass(true);
    } else {
      setBodyClass(false);
    }
  });

  let classRemoved = false;

  window.addEventListener(
    "scroll",
    () => {
      if (!classRemoved && window.scrollY >= 200) {
        setBodyClass(false);
        classRemoved = true;
      }
    },
    { passive: true }
  );
})();
